(function () {
  function initCopyButtons(root) {
    root.querySelectorAll('[data-reewards-copy]').forEach(function (btn) {
      if (btn.dataset.reewardsCopyBound) return;
      btn.dataset.reewardsCopyBound = 'true';

      var code = btn.getAttribute('data-code') || '';
      var defaultLabel = (btn.textContent || 'Copy').trim();

      btn.addEventListener('click', function () {
        if (!code) return;

        var onCopied = function () {
          btn.classList.add('is-copied');
          btn.textContent = '✓';
          btn.setAttribute('aria-label', 'Copied');

          window.setTimeout(function () {
            btn.classList.remove('is-copied');
            btn.textContent = defaultLabel;
            btn.setAttribute('aria-label', 'Copy discount code');
          }, 3000);
        };

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(onCopied).catch(function () {
            fallbackCopy(code, onCopied);
          });
        } else {
          fallbackCopy(code, onCopied);
        }
      });
    });
  }

  function fallbackCopy(text, onSuccess) {
    var textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'absolute';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();

    try {
      document.execCommand('copy');
      onSuccess();
    } catch (err) {
      console.error(err);
    }

    document.body.removeChild(textarea);
  }

  function initViewMore(root) {
    var grid = root.querySelector('[data-reewards-grid]');
    var btn = root.querySelector('[data-reewards-view-more]');
    if (!grid || !btn || btn.tagName === 'A') return;

    btn.addEventListener('click', function () {
      grid.classList.add('is-expanded');
      var wrap = btn.closest('.reewards-progrid__view-more-wrap');
      if (wrap) {
        wrap.classList.add('is-hidden');
      } else {
        btn.classList.add('is-hidden');
      }
    });
  }

  var SCROLL_KEY = 'reewards-progrid-scroll';

  function storageSet(value) {
    try {
      sessionStorage.setItem(SCROLL_KEY, value);
      localStorage.setItem(SCROLL_KEY, value);
    } catch (err) {}
  }

  function storageGet() {
    try {
      return sessionStorage.getItem(SCROLL_KEY) || localStorage.getItem(SCROLL_KEY);
    } catch (err) {
      return null;
    }
  }

  function storageClear() {
    try {
      sessionStorage.removeItem(SCROLL_KEY);
      localStorage.removeItem(SCROLL_KEY);
    } catch (err) {}
  }

  function initLoginScroll(root) {
    root.querySelectorAll('[data-reewards-login-scroll]').forEach(function (link) {
      if (link.dataset.reewardsLoginBound) return;
      link.dataset.reewardsLoginBound = 'true';
      link.addEventListener('click', function () {
        var id = root.id || link.getAttribute('data-reewards-login-scroll');
        if (id) storageSet(id);
      });
    });
  }

  function scrollToModule() {
    var params = new URLSearchParams(window.location.search);
    var id = params.get('rpg_scroll');
    if (id && id.indexOf('section_') !== 0) id = 'section_' + id;
    if (!id) id = storageGet();
    if (!id && window.location.hash) id = window.location.hash.replace('#', '');
    if (!id) return;

    var target = document.getElementById(id);
    if (!target || !target.hasAttribute('data-reewards-progrid')) return;

    storageClear();
    if (params.has('rpg_scroll') && window.history && window.history.replaceState) {
      params.delete('rpg_scroll');
      var next = window.location.pathname + (params.toString() ? '?' + params.toString() : '') + window.location.hash;
      window.history.replaceState({}, '', next);
    }

    var run = function () {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };
    window.requestAnimationFrame(run);
    window.setTimeout(run, 400);
  }

  function initSection(root) {
    initCopyButtons(root);
    initViewMore(root);
    initLoginScroll(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-reewards-progrid]').forEach(initSection);
    scrollToModule();
  });

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-reewards-progrid]');
    if (root) initSection(root);
  });
})();
